import { createElementVNode as _createElementVNode, withModifiers as _withModifiers, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, vShow as _vShow, withDirectives as _withDirectives, createVNode as _createVNode, Teleport as _Teleport, Fragment as _Fragment } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_ConfirmDelete = _resolveComponent("ConfirmDelete")!
  const _component_ContextMenu = _resolveComponent("ContextMenu")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.cmOpener.open($event, _ctx.id)), ["prevent","stop"])),
      class: "w-10 h-6 bg-next-gray-md-dark cursor-pointer text-center inset-0 flex items-center justify-center drag-handle"
    }, _cache[10] || (_cache[10] = [
      _createElementVNode("i", { class: "block text-center icon-opzioni" }, null, -1)
    ])),
    (_openBlock(), _createBlock(_Teleport, { to: _ctx.teleport_to }, [
      _createVNode(_component_ContextMenu, {
        id: _ctx.id,
        "menu-class": _ctx.menuClass,
        cmOpener: _ctx.cmOpener
      }, {
        default: _withCtx(() => [
          (!(_ctx.context._alternativa || _ctx.context._nuvola || _ctx.context.nuvole || _ctx.context.alternative))
            ? (_openBlock(), _createElementBlock("span", {
                key: 0,
                class: "cursor-pointer hover:text-next-neu mb-2",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('toggleDescrizione')))
              }, _toDisplayString(_ctx.isDescrizione(_ctx.context)? 'Riga preventivo': 'Riga descrizione'), 1))
            : _createCommentVNode("", true),
          (!(_ctx.context._alternativa || _ctx.context._nuvola || _ctx.context.nuvole || _ctx.context.alternative))
            ? (_openBlock(), _createElementBlock("span", {
                key: 1,
                class: "cursor-pointer hover:text-next-neu mb-2",
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('toggleOpzionale')))
              }, _toDisplayString(_ctx.isOpzionale(_ctx.context)? 'Riga preventivo': 'Riga opzionale'), 1))
            : _createCommentVNode("", true),
          (!(_ctx.context._alternativa || _ctx.context._nuvola) && !_ctx.context.nuvole && !_ctx.isDescrizione(_ctx.context) && !_ctx.isOpzionale(_ctx.context))
            ? (_openBlock(), _createElementBlock("span", {
                key: 2,
                class: "cursor-pointer hover:text-next-neu mb-2",
                onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('addAlternativa')))
              }, "Riga alternativa"))
            : _createCommentVNode("", true),
          (!(_ctx.context._alternativa || _ctx.context._nuvola) && !_ctx.context.alternative  && !_ctx.isDescrizione(_ctx.context) && !_ctx.isOpzionale(_ctx.context))
            ? (_openBlock(), _createElementBlock("span", {
                key: 3,
                class: "cursor-pointer hover:text-next-neu mb-2",
                onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$emit('addNuvola')))
              }, "Riga nuvola"))
            : _createCommentVNode("", true),
          (!(_ctx.context._alternativa || _ctx.context._nuvola))
            ? (_openBlock(), _createElementBlock("span", {
                key: 4,
                class: "cursor-pointer hover:text-next-neu mb-2",
                onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.$emit('duplicaRecord')))
              }, "Duplica"))
            : _createCommentVNode("", true),
          ((_ctx.context._alternativa || _ctx.context._nuvola))
            ? (_openBlock(), _createElementBlock("span", {
                key: 5,
                class: "cursor-pointer hover:text-next-neu mb-2",
                onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.$emit('duplicaSottoRecord')))
              }, "Duplica"))
            : _createCommentVNode("", true),
          (_ctx.context?.ne_fornitore)
            ? (_openBlock(), _createBlock(_component_router_link, {
                key: 6,
                to: {name:'DettaglioFornitore', params: {fid:_ctx.context?.ne_fornitore?.id}},
                class: "cursor-pointer hover:text-next-neu mb-2"
              }, {
                default: _withCtx(() => _cache[11] || (_cache[11] = [
                  _createTextVNode("Vai al fornitore")
                ])),
                _: 1
              }, 8, ["to"]))
            : _createCommentVNode("", true),
          _withDirectives(_createElementVNode("span", {
            class: "cursor-pointer hover:text-next-neu mb-2",
            onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.$emit('promuovi')))
          }, "Rendi principale", 512), [
            [_vShow, (_ctx.context._alternativa)]
          ]),
          _withDirectives(_createVNode(_component_ConfirmDelete, {
            position: "right",
            onCancella: _cache[8] || (_cache[8] = ($event: any) => (_ctx.$emit('cancella')))
          }, {
            default: _withCtx(() => _cache[12] || (_cache[12] = [
              _createElementVNode("span", { class: "cursor-pointer hover:text-next-neu" }, "Elimina", -1)
            ])),
            _: 1
          }, 512), [
            [_vShow, !(_ctx.context._alternativa || _ctx.context._nuvola)]
          ]),
          _withDirectives(_createVNode(_component_ConfirmDelete, {
            position: "right",
            onCancella: _cache[9] || (_cache[9] = ($event: any) => (_ctx.$emit('eliminaSottoriga')))
          }, {
            default: _withCtx(() => _cache[13] || (_cache[13] = [
              _createElementVNode("span", { class: "cursor-pointer hover:text-next-neu" }, "Elimina sottoriga", -1)
            ])),
            _: 1
          }, 512), [
            [_vShow, (_ctx.context._alternativa || _ctx.context._nuvola)]
          ])
        ]),
        _: 1
      }, 8, ["id", "menu-class", "cmOpener"])
    ], 8, ["to"]))
  ], 64))
}